//@ts-check

import { isElementInViewport } from "../utils/helper";

document.addEventListener("DOMContentLoaded", () => {
    /** @type {NodeListOf<HTMLDivElement>} */
    const accordions = document.querySelectorAll(".accordion");
    for (const accordion of accordions) {
        accordion.addEventListener("shown.bs.collapse", function (e) {
            const target = /** @type {HTMLElement} */ (e.target)
            const $target = $(target)
            var $card = $target.closest('.accordionDiv');
            var $open = $(accordion).find('.accordionDiv > .collapse.show');

            var parent = $open.parent().get(0)

            console.log("[Accordion] Closed", { target, accordion, $card, $open, parent })
            if (!parent) {
                console.warn("[Accordion] no parent", { accordion })
                return
            }

            if ([...target?.parentElement?.children ?? []].find(child => child.classList.contains("accChild"))) {
                console.info("[Accordion] skipping nested accordion", { target })
                return
            }

            const isInView = isElementInViewport(parent)

            if (isInView) {
                return
            }

            const offset = $card.offset()

            if (offset) {
                const scrollLength = offset.top - 200
                console.log("[Accordion]", { scrollLength })
                $('html,body').animate({
                    scrollTop: scrollLength
                }, "fast");
            }
            else {
                console.warn("[Accordion] no offset")
            }
        })
    }
})
